import CheckIcon from '@mui/icons-material/CheckRounded'
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded'
import { Stack, Tooltip, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { passwordSymbols } from '../../utils'

type Props = {
  hasNumber: boolean
  hasSymbol: boolean
  hasUpperCase: boolean
  hasLowerCase: boolean
  hasMinLength: boolean
}

const PasswordRules = ({
  hasNumber,
  hasSymbol,
  hasUpperCase,
  hasLowerCase,
  hasMinLength,
}: Props) => {
  const { t } = useTranslation('auth')

  return (
    <Stack>
      <Typography>{t('passwordRules')}</Typography>
      <Stack direction="row" alignItems="center" spacing={1}>
        <CheckIcon sx={{ visibility: hasNumber ? 'unset' : 'hidden' }} color="success" />
        <Typography variant="body2">{t('needsNumber')}</Typography>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1}>
        <CheckIcon sx={{ visibility: hasSymbol ? 'unset' : 'hidden' }} color="success" />
        <Typography variant="body2">
          {t('needsSymbol')}{' '}
          <Tooltip
            title={
              <Typography variant="body2">
                {t('symbolsMayInclude', { symbols: passwordSymbols.split('').join(' ') })}
              </Typography>
            }
          >
            <HelpOutlineRoundedIcon fontSize="inherit" color="info" />
          </Tooltip>
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1}>
        <CheckIcon sx={{ visibility: hasUpperCase ? 'unset' : 'hidden' }} color="success" />
        <Typography variant="body2">{t('needsUpperCase')}</Typography>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1}>
        <CheckIcon sx={{ visibility: hasLowerCase ? 'unset' : 'hidden' }} color="success" />
        <Typography variant="body2">{t('needsLowerCase')}</Typography>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1}>
        <CheckIcon sx={{ visibility: hasMinLength ? 'unset' : 'hidden' }} color="success" />
        <Typography variant="body2">{t('passwordErrorTooShort')}</Typography>
      </Stack>
    </Stack>
  )
}

export default PasswordRules
